// "Show more / Show less" for the client Q&A list (visible at <= $tab only).
// This entry is shared by hair-salon + barbershop (review-story--embed partial).
// nail-salon used to bring its own `.hair__faq-list` markup here too, but master
// rebuilt it as a vertical page on event_booking_system_js, so that pair is gone.
const QA_BLOCKS = [
    { wrapper: '.review-story__qa-wrapper', list: '.review-story__qa-list' },
];

QA_BLOCKS.forEach(function (block) {
    $(block.wrapper + ' .btn-bar .accordion_toggler').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('opened');
        let txtBlock = $(this).closest(block.wrapper).find(block.list).toggleClass('full-review');

        if (!$(txtBlock).hasClass("full-review")) {
            txtBlock.animate({ 'max-height': 370 });
        } else {
            txtBlock.animate({'max-height': txtBlock[0].scrollHeight + "px"});
        }
    });
});
